import React, { forwardRef } from 'react';

import { AGE_OPTIONS } from '@vlabs/api-bindings/src/constants';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { Radio } from '@vlabs/uikit/components/controls/radio';
import equal from 'fast-deep-equal';

import { useWorkspaceFilters } from '../../useWorkspaceFilters';
import st from '../FilterPopovers.module.sass';

interface AgeOption {
  label: string;
  value: number[];
}

function AgeFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { filters, updateFilters } = useWorkspaceFilters();
  const selectedAge = filters.age;

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={selectedAge === undefined}
      onClickReset={() => updateFilters({ age: undefined })}
      ref={ref}
    >
      <div className={st.RadioWrapper}>
        {(AGE_OPTIONS.raw as AgeOption[]).map((option) => (
          <Radio
            checked={equal(selectedAge?.value, option.value)}
            key={option.label}
            label={option.label}
            onChange={() => updateFilters({ age: option })}
          />
        ))}
      </div>
    </PopoverWithButton>
  );
}

const AgeFilterPopoverWithRef = forwardRef(AgeFilterPopover);
export { AgeFilterPopoverWithRef as AgeFilterPopover };
